<template>
  <v-form v-model="valid" ref="mainForm">
    <data-iterator
      :list="sas.formateurs"
      add-new-text="Ajouter un formateur"
      :live="{ endpoint: 'sas-formateur', sasId: sas.id }"
      :icon="$getIcon('teacher')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3>{{ item.prenom }} {{ item.nom }}</h3>
      </template>

      <template v-slot:edit-mode="{ item }">
        <opq-catalogue code="formateur-titre-professionnel" v-model="item.titreProfessionnelAuQuebec" :live="liveSasFormateur(10802, item)">
        </opq-catalogue>

        <search-numero-permis
          v-if="estPsychologue(item) || estPsychotherapeute(item)"
          @contact-selected="contactSelected($event, item.id)"
        ></search-numero-permis>

        <opq-text-field
          :opq-if="estPsychologue(item) || estPsychotherapeute(item)"
          code="formateur-numero-permis"
          v-model="item.numeroPermisAuQuebec"
          :ref="'numeroPermis-' + item.id"
          :live="liveSasFormateur(10804, item)"
          :disabled="estPsychologue(item) || estPsychotherapeute(item)"
        >
        </opq-text-field>

        <opq-text-field
          code="formateur-prenom"
          v-model="item.prenom"
          :ref="'prenom-' + item.id"
          :live="liveSasFormateur(10806, item)"
          :disabled="estPsychologue(item) || estPsychotherapeute(item)"
        >
        </opq-text-field>

        <opq-text-field
          code="formateur-nom"
          v-model="item.nom"
          :ref="'nom-' + item.id"
          :live="liveSasFormateur(10805, item)"
          :disabled="estPsychologue(item) || estPsychotherapeute(item)"
        >
        </opq-text-field>

        <opq-text-field
          :opq-if="estAutre(item)"
          code="formateur-autre-titre"
          v-model="item.autreTitreProfessionnel"
          :live="liveSasFormateur(10803, item)"
        >
        </opq-text-field>

        <div v-if="estFormation || (estEvenement && nEstPasComiteScientifique)">
          <ressource code="info-cv"></ressource>
        </div>

        <opq-file
          :opq-if="estFormation || (estEvenement && nEstPasComiteScientifique)"
          code="formateur-cv"
          :file="item.cv"
          :live="liveSasFormateur(10808, item)"
        ></opq-file>

        <div v-if="estEvenement && estComiteScientifique">
          <ressource code="info-bio"></ressource>
        </div>

        <opq-file
          :opq-if="estEvenement && estComiteScientifique"
          code="formateur-bio"
          :file="item.biographie"
          :live="liveSasFormateur(10809, item)"
        ></opq-file>
      </template>
    </data-iterator>

    <div>
      <ressource code="attestation-probite-formateurs"></ressource>
    </div>

    <opq-case
      code="formateur-attestation-probite"
      v-model="sasReconnaissanceDeFormation.attestationDeProbite"
      :live="liveSasReconnaissanceFormation(10708)"
    ></opq-case>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import SearchNumeroPermis from "@/components/Common/SearchNumeroPermis"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  components: { SearchNumeroPermis },
  props: {
    sas: { type: Object }
  },

  computed: {
    sasReconnaissanceDeFormation() {
      return this.sas.sasReconnaissanceDeFormation
    },

    estFormation() {
      return this.getCatalogueCodeById(9811, this.sasReconnaissanceDeFormation.typeDActivite) == "1"
    },

    estEvenement() {
      return this.getCatalogueCodeById(9811, this.sasReconnaissanceDeFormation.typeDActivite) == "2"
    },

    estComiteScientifique() {
      return this.estOui(this.sasReconnaissanceDeFormation.ateliersApprouvesParUnComiteScientifique)
    },

    nEstPasComiteScientifique() {
      return this.estNon(this.sasReconnaissanceDeFormation.ateliersApprouvesParUnComiteScientifique)
    }
  },

  methods: {
    liveSasFormateur(cle, item) {
      return { endpoint: "/sas-formateur/", cle: cle, fileId: item.id }
    },

    liveSasReconnaissanceFormation(cle) {
      return { endpoint: "/sas-reconnaissance-formation/", cle: cle, fileId: this.sasReconnaissanceDeFormation.id }
    },

    contactSelected(contact, id) {
      this.$refs["numeroPermis-" + id].setValue(contact.numeroPermis)
      this.$refs["prenom-" + id].setValue(contact.prenom)
      this.$refs["nom-" + id].setValue(contact.nom)
    },

    estPsychologue(item) {
      return this.getCatalogueCodeById(9902, item.titreProfessionnelAuQuebec) == "1PS"
    },

    estPsychotherapeute(item) {
      return this.getCatalogueCodeById(9902, item.titreProfessionnelAuQuebec) == "2PT"
    },

    estAutre(item) {
      return this.getCatalogueCodeById(9902, item.titreProfessionnelAuQuebec) == "3Autre"
    }
  }
}
</script>

<style>
</style>